import { useEffect } from "react";
import { Box, Container } from "@mui/material";
import { useErrorContext } from "../../global/hooks/useErrorContext";
import { Navigate } from "react-router-dom";
import { useCphContext } from "../hooks/useCphContext";
import { useCphDataContext } from "../hooks/useCphDataContext";
import CphLandingView from "./CphLandingView";

//This component is responsible for displaying the cph content.
export default function CphRouter() {
    const { isSingleIssue } = useCphContext();
    const { selectedIssue, setShowIssue } = useCphDataContext();
    const { error } = useErrorContext();

    useEffect(() => {
        if (isSingleIssue && selectedIssue !== null) {
            setShowIssue(true);
        }
    }, [isSingleIssue, selectedIssue, setShowIssue]);

    if (error) {
        return <Navigate to="/error" />;
    }

    return (
            <Container maxWidth={false}>
                <Box
                    sx={{
                        width: '100%',
                        maxWidth: { xs: '100%', sm: 700, md: 1000, lg: 1400 },
                        mx: 'auto',
                        px: { xs: 1, sm: 2, md: 3 },
                        py: { xs: 1, sm: 2, md: 3 },
                    }}
                >
                    <CphLandingView />
                </Box>
            </Container>
    );
}